<template>
  <img :src="logoSrc" :alt="alt" v-bind="$attrs" v-on="$listeners">
</template>

<script>
import defaultLogo from '@/assets/img/logos/ideaBuddy-color.svg'
import { mapGetters } from 'vuex'

export default {
  name: 'IbBrandLogo',

  inheritAttrs: false,

  props: {
    alt: {
      type: String,
      default: 'Logo'
    }
  },

  computed: {
    ...mapGetters('appSettings', ['effectiveLogo']),

    logoSrc () {
      return this.effectiveLogo || defaultLogo
    }
  }
}
</script>
